import { Paper } from "@mui/material";
import { useRouter } from "next/router";
import { useUserData } from "../../hooks/useUserData";

export default function ProfileText() {
  const { query } = useRouter();
  const { actDroner } = useUserData();
  const isMyProfile = () => actDroner?.username === query?.username;

  return (
    <Paper sx={{ mt: 4, mb: 2, px: 3, py: 2, border: "#2496CC 1px solid" }}>
      {isMyProfile()
        ? "Adj hozzá képeket a profilodhoz, hogy minél több érdeklődő figyelmét felkeltsd!"
        : "Hoppá! Úgy tűnik ez a pilóta még nem töltötte fel referenciamunkáit.\n" +
          "Vedd fel vele a kapcsolatot, és fejezd ki érdeklődésed minél hamarabb!"}
    </Paper>
  );
}
